//import Moment from "moment";

const getCount = (state) => {
	return state.horimetroKM.length;
}

export default {
	getCount
}